import { render, staticRenderFns } from "./DataBusca.vue?vue&type=template&id=618121f1"
import script from "./DataBusca.vue?vue&type=script&lang=js"
export * from "./DataBusca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports